import * as Sentry from '@sentry/browser';
import {createTracker} from '@ezcater/tracker-js';
import {IEventDictionary} from '@ezcater/tracker-js/dist/types';

const eventDictionary: IEventDictionary = {
  namespace: 'Store',
  events: {
    'consumer-cart-data-loaded': {
      description: 'data loads for the consumer cart and the red dot shows or not',
      properties: {
        misc_json: {
          description: 'includes the number of orders (carts) in the popover/modal',
          type: ['string', 'null'],
        },
      },
    },
    'consumer-cart-opened': {
      description: 'user opens the consumer cart popover or modal',
      properties: {},
    },
    'consumer-cart-order-clicked': {
      description: 'user clicks an order (cart) in the modal or popover',
      properties: {
        order_id: {
          description: 'The order id',
          type: 'string',
        },
      },
    },
  },
};

const runningLocally = window.location.host === 'localhost:3000';

const START_NEW_ORDER_PATH = '/start-new-order';
export const SIGN_IN_PATH = '/sign_in';

const STORE_NEXT_LOCAL_HOST = 'http://localhost:22030';

const RUDDERSTACK_DATA_PLANE_URL_JS = (document.head.querySelector("meta[name=rudderstack_data_plane_url_js]") as HTMLMetaElement)?.content;
const RUDDERSTACK_FF_ENABLED = (document.head.querySelector("meta[name=rudderstack_ff_enabled]") as HTMLMetaElement)?.content;
const RUDDERSTACK_WRITE_KEY = (document.head.querySelector("meta[name=rudderstack_write_key]") as HTMLMetaElement)?.content;
const RUDDERSTACK_CONFIG_URL = (document.head.querySelector("meta[name=rudderstack_config_url]") as HTMLMetaElement)?.content;
const RUDDERSTACK_SDK_BASE_URL = (document.head.querySelector("meta[name=rudderstack_sdk_base_url]") as HTMLMetaElement)?.content;

const tracker = createTracker(
  eventDictionary,
  {
    rudderstackWriteKey: RUDDERSTACK_WRITE_KEY,
    rudderstackDataPlaneUrl: RUDDERSTACK_DATA_PLANE_URL_JS,
    rudderstackFFEnabled: RUDDERSTACK_FF_ENABLED,
    rudderstackConfig: {
      configUrl: RUDDERSTACK_CONFIG_URL,
      pluginsSDKBaseURL: `${RUDDERSTACK_SDK_BASE_URL}/v3/modern/plugins`,
      destSDKBaseURL: `${RUDDERSTACK_SDK_BASE_URL}/v3/modern/js-integrations`,
    },
  }
);

const compileOrderPath = ({orderId, catererUrlId}) => `/store/caterer/${orderId}?c=${catererUrlId}`;

const compileOrderPathDevelopment = ({orderId, catererUrlId}) =>
  STORE_NEXT_LOCAL_HOST + compileOrderPath({orderId, catererUrlId});

export const consumerCartProps = {
  compileOrderPath: runningLocally ? compileOrderPathDevelopment : compileOrderPath,

  onError: e => Sentry.captureException(e),

  onLoadData: carts =>
    tracker.track('consumer-cart-data-loaded', {
      misc_json: JSON.stringify({cartCount: carts.length}),
    }),

  onOpen: () => tracker.track('consumer-cart-opened'),

  onClickOrder: order => tracker.track('consumer-cart-order-clicked', {order_id: order.id}),
};

export const startNewOrderPath = runningLocally
  ? STORE_NEXT_LOCAL_HOST + START_NEW_ORDER_PATH
  : START_NEW_ORDER_PATH;
